/**
 * Retired path. Entitlement moved out of the tenant's Settings to
 * /tenants/$slug/entitlement; bookmarks keep resolving.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/tenants/$slug/settings/product-areas/reconciliation")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/tenants/$slug/entitlement", params: { slug: params.slug }, replace: true });
  },
});
